module.exports = __webpack_public_path__ + "assets/2-Los-Angeles-SDR-careers.4c2f519c.png";